import { render } from "./재활의학과.vue?vue&type=template&id=ab425a6e"
import script from "./재활의학과.vue?vue&type=script&lang=js"
export * from "./재활의학과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__